var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6439 3.03442C10.1551 3.03442 7.28809 5.86201 7.28809 9.37925V19.3103C7.28809 19.6896 7.59897 19.9999 7.97893 19.9999H11.5713C11.9513 19.9999 12.2622 19.6896 12.2622 19.3103V9.65511C12.2622 8.89649 12.8839 8.2758 13.6439 8.2758C14.4038 8.2758 15.0256 8.89649 15.0256 9.65511V19.3103C15.0256 19.6896 15.3364 19.9999 15.7164 19.9999H19.3088C19.6888 19.9999 19.9997 19.6896 19.9997 19.3103V9.37925C19.9997 5.89649 17.1672 3.03442 13.6439 3.03442Z",
    fill: "#DBD8D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28325 6.27588H0.690846C0.310881 6.27588 0 6.58622 0 6.96553V19.3104C0 19.6897 0.310881 20 0.690846 20H4.28325C4.66321 20 4.97409 19.6897 4.97409 19.3104V6.96553C4.97409 6.58622 4.66321 6.27588 4.28325 6.27588Z",
    fill: "#DBD8D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48705 0C1.10535 0 0 1.10345 0 2.48276C0 3.86207 1.10535 4.96552 2.48705 4.96552C3.86874 4.96552 4.97409 3.86207 4.97409 2.48276C4.97409 1.10345 3.86874 0 2.48705 0Z",
    fill: "#DBD8D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.edcc496b6ef45adce4c5664045c23d26.svg";
export { ForwardRef as ReactComponent };